var request = require('./request');
var Promise = require('bluebird');
var qs = require('../../common/question-sets/qs.json');
var config = require('./config');
var resolve = require('./resolve');

exports.AdminGetLatest = function(userId){
  // return Promise.resolve(qs);
  return request.get(resolve(config.url(), '/questions/admin/application/latest')).promise();
}

exports.AdminSaveLatest = function(obj){
  return request.post(resolve(config.url(), '/questions/admin/application'), obj).promise();
}
